"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldNames = exports.FieldTypes = void 0;
var FieldTypes;
(function (FieldTypes) {
    FieldTypes["EmailAddress"] = "EMAIL_ADDRESS";
    FieldTypes["BusinessUnit"] = "BUSINESS_UNIT";
    FieldTypes["LeaderName"] = "LEADER_NAME";
    FieldTypes["EmployeeId"] = "EMPLOYEE_ID";
    FieldTypes["ParentBusinessUnit"] = "PARENT_BUSINESS_UNIT";
    FieldTypes["JobTitle"] = "JOB_TITLE";
    FieldTypes["WorkLocation"] = "WORK_LOCATION";
    FieldTypes["WorkLocationCondensed"] = "WORK_LOCATION_CONDENSED";
})(FieldTypes = exports.FieldTypes || (exports.FieldTypes = {}));
var FieldNames;
(function (FieldNames) {
    FieldNames["EmailAddress"] = "Email address";
    FieldNames["BusinessUnit"] = "Business unit";
    FieldNames["LeaderName"] = "Leader name";
    FieldNames["EmployeeId"] = "Employee ID";
    FieldNames["ParentBusinessUnit"] = "Parent Business Unit";
    FieldNames["JobTitle"] = "Job Title";
    FieldNames["WorkLocation"] = "Work Location";
    FieldNames["WorkLocationCondensed"] = "Work Location (Condensed)";
})(FieldNames = exports.FieldNames || (exports.FieldNames = {}));
//# sourceMappingURL=interfaces.js.map